import React from "react";

export default class extends React.Component {
    render() {
        const {setting} = this.props;
        const footerSetting = setting ? setting["footer"] : undefined;

        if (footerSetting == "thin" ) {
          return (<dwc-footer theme='dark' thin />);
        }

        if (footerSetting == "none") {
          return null;
        }

        if (footerSetting == "developer") {
          return (<dwc-footer />);
        }

        return (<dwc-footer theme='dark' />);
    }
}